
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { khoApi } from '../../../api/category/khoApi';
import { IKho } from '../../../model/respone/category/IKho';
import { IBaseRespone } from '../../../model/respone/IBaseRespone';
import { eKhoActionTypeIds, IKhoActions } from "../../action-types/category/IKhoActionTypes";
import { rootActions } from '../../actions/rootActions';
const mainAction = rootActions.category.kho;
export function* khoSaga(): any {
    yield takeLatest(eKhoActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eKhoActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eKhoActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: IKhoActions): any {
    const res: IBaseRespone = yield call(khoApi.SelectAll)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveWorker(action: IKhoActions): any {
    let res: IBaseRespone;
    const Kho = action.payload as IKho;
    if (Kho.id > 0) {
        res = yield call(khoApi.Update, Kho)
    } else {
        res = yield call(khoApi.Insert, Kho)
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data))
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
    }
}

function* deleteWorker(action: IKhoActions): any {
    const res: IBaseRespone = yield call(khoApi.Delete, action.payload as number)
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data))
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"))
    }
}